import { Row, Col, Image, Typography, Alert } from "antd";

import image1 from "../../../assets/images/image1.png";
import LandingImage from "../../../assets/images/Landingimage.jpg";
import vikasLogo from "../../../assets/images/vikas-logo.jpg";
import sampark from "../../../assets/images/logo.png";
import engageLogo from "../../../assets/images/engage-logo.jpg";
import Head from "../../../components/sectionHead";
import orange from "../../../assets/images/orange_line.png";
import vikas from "../../../assets/images/vikas.png";
import spices from "../../../assets/images/spices.jpg";
import pulses from "../../../assets/images/pulses.jpg";
import trading from "../../../assets/images/trading.jpeg";

const { Title: AntTitle, Paragraph } = Typography;

export default function whatweoffer() {
  return (
    <div className="contact-wrapper container-fluid" id="whatweoffer">
      {/* <Head title={"What We Offer"} /> */}
      <div className="section-image">
        <Image src={sampark} className="image-logo" preview={false} />
      </div>
      {/* SamparkBindhu*/}
      <Row className="samparkbindhu-row" gutter={36} align="middle">
        <Col span={12} xs={24} md={12}>
          <Row className="title-row" align="middle" justify="start">
            <Image className="image-mobile" preview={false} src={image1} />
          </Row>
          <Row className="details-row" align="middle" >
            <AntTitle level={4} className="what-we-offer-title">
              Problem Faced
            </AntTitle>
            <div className="what-text">
              There is a large disparity in price of produce between farmer and
              retail. The overheads associated with Supply Chain, Transport,
              Wastage, Storage, packing, seasonal vagaries add up the costs. The
              outcome results in high disparity with low prices to the farmer
              and high prices to the end consumer. Government policies were
              recently amended to allow direct selling of produce. Adoption is
              however very limited.
            </div>
            <AntTitle level={4} className="what-we-offer-title">
              <br />Solution
            </AntTitle>
            <Paragraph className="paragraph">
              We aim to Enable value addition in the Agri post-harvest space. By deploying our proprietary phygital framework directly into these Tier 2 and Tier 3 villages, we empower local traders, FPOs, and farmers with institutional-grade technology.
              <ul>
                <li>
                  Ensure basic value addition by enabling trading with quality targeting Institutional buyers - Enable the farmer with the best price for his produce.
                </li>
                <li>SAAS enabled B2B inventory and Finance Management Software to help Rural traders and FPOs manage their CRM workflow.</li>
                <li>
                  Create a new efficient, optimized technology driven marketplace.
                </li>
              </ul>
              <AntTitle level={4} className="what-we-offer-title">
              </AntTitle>
            </Paragraph>
          </Row>
        </Col>
        <Col span={12} xs={24} md={12}>
          <Image className="image-web slide-right" preview={false} src={image1} />
        </Col>
      </Row>

      {/*Trading*/}
      <div id="trading">
        <Head title="Trading" />
      </div>
      <div className="section-image">
        <Image src={sampark} className="image-logo" preview={false} />
      </div>
      <Row className="trading-row" gutter={36} align="middle" id="trading">
        <Col span={12} xs={24} md={12} className="trading-img-center">
          <Image className="trading-img slide-left" preview={false} src={trading} />
        </Col>
        <Col span={12} xs={24} md={12}>
          <Row className="title-row" align="middle" justify="start">
            {/* <Image src={tradingLogo} className="image-logo" preview={false} /> */}
            {/* <AntTitle className="title">Trading</AntTitle> */}
            <Image className="image-mobile" preview={false} src={trading} />
          </Row>
          <Row className="details-row" align="middle" >
            <AntTitle level={4} className="what-we-offer-title">
              Problem Faced
            </AntTitle>
            <div className="what-text">
              Agri commodity B2B players in India's agriculture sector have historically resisted SaaS solutions due to discomfort with their reliability and scalability. While numerous AgriTech startups entered the market, approximately 90% failed to achieve meaningful impact or sustainability. This high failure rate has eroded confidence across the agri ecosystem, stifling adoption of software-driven innovations
            </div>
            <AntTitle level={4} className="what-we-offer-title">
              <br />Solution
            </AntTitle>
            <Paragraph className="paragraph">
              <ul>
                <li>
                  Building Trust Through Phygital Trading Engine.
                </li>
                <li>To rebuild confidence among institutional buyers and rural stakeholders, we launched a hands-on trading exercise powered by our phygital platform, SamparkBindhu.</li>
                <li>
                  This strategic pivot delivers:
                  <li>
                    Ground-Level Credibility: Establishes us as a committed ecosystem player, fostering trust with key stakeholders.
                  </li>
                  <li>
                    Rigorous SaaS Validation: Tests and refines our full inventory and accounting software suite in real-world conditions.
                  </li>
                  <li>
                    Scalable Growth Engine: Seamlessly transitions existing customers to our flagship SaaS applications—VikasBandhu and EngageAll—driving rapid expansion.
                  </li>
                  <li>
                    This phygital approach bridges physical trading with digital innovation, positioning us for sustainable SaaS adoption at scale.
                  </li>
                </li>
              </ul>
            </Paragraph>
          </Row>
        </Col>
      </Row>

      <div id="solutions">
        <Head title="Our Solutions" />
        {/*EngageAll*/}
        <div className="section-image left-logo">
          <Image src={engageLogo} className="image-logo" preview={false} />
        </div>
        <Row className="engageall-row" gutter={36} align="middle">
          <Col span={12} xs={24} md={12}>
            <Row className="title-row" align="middle" justify="start">
              <Image className="image-mobile" preview={false} src={LandingImage} />
            </Row>
            <Row className="details-row" align="middle" justify="start">
              <AntTitle level={4} className="what-we-offer-title">
                <br /> Problem Faced
              </AntTitle>
              <div className="what-text">
                An B2B CRM platform for Rural Industries and Farmer Organizations to
                Handle the everyday needs of Bulk inventory across Warehouses,
                Stores, and Gowdowns.
              </div>
                <AntTitle level={4} className="what-we-offer-title">
                  <br /> Solution
                </AntTitle>
                <Paragraph className="paragraph">
                <ul>
                  <li>This is an Ideal B2B CRM platform for Rural Industries (FPOs, Societies, Stockists, Godowns, Wholesalers, retailers, Logistics, etc).</li>
                  <li>It handles the everyday needs of bulk inventory across  multiple warehouses, godowns, and stores.</li>
                  <li>Ensuring timely stock replenishment and inventory turnover.</li>
                  <li>Provides the accounting related documentation.</li>
                  <li>Coupled with data-driven  strategies and reports providing insights for efficiency and profitability.</li>
                  <li>It is driven by the ease of use approach providing  Management of Godowns/Stores, Stocks, and Orders with the needed GST compliance.</li>
                </ul>
                </Paragraph>
              <div>
                <b style={{ display: "block", marginBottom: "12px" }}>Application available  as Dev Release (pilot validation).</b>
                <Image src={orange} preview={false} />
                <b>Visit us at:</b>{" "}
                <a
                  href="https://engageall.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <strong> engageall.in</strong>
                </a>
                <b>{" "}for more information</b><br />
              </div>

              <div className="app-download-row">
                <strong >EngageAll App</strong>
                <a
                  href="https://play.google.com/store/apps/details?id=com.engageall&hl=en_IN"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                    alt="Get it on Google Play"
                    style={{ width: "100px" }}
                  />
                </a>
                <Image src={orange} preview={false} />
              </div>
            </Row>
          </Col>
          <Col span={12} xs={24} md={12}>
            <Image className="image-web slide-right" preview={false} src={LandingImage} />
          </Col>
        </Row>
        <br />

        {/*VikasBandhu*/}
        <div className="section-image left-logo">
          <Image src={vikasLogo} className="image-logo" preview={false} />
        </div>
        <Row className="vikasbandhu-row" gutter={36} align="middle">
          <Col span={12} xs={24} md={12}>
            <Image className="image-web slide-left" preview={false} src={vikas} />
          </Col>
          <Col span={12} xs={24} md={12}>
            <Row className="title-row" align="middle" justify="start">
              <Image className="image-mobile" preview={false} src={vikas} />
            </Row>
            <Row className="details-row" align="middle" >
              <AntTitle level={4} className="what-we-offer-title">
                Problem Faced
              </AntTitle>
              <div className="what-text">
                There is a large disparity in price of produce between farmer and
                retail. The overheads associated with Supply Chain, Transport,
                Wastage, Storage, packing, seasonal vagaries add up the costs. The
                outcome results in high disparity with low prices to the farmer
                and high prices to the end consumer. Government policies were
                recently amended to allow direct selling of produce. Adoption is
                however very limited.
              </div>
              <AntTitle level={4} className="what-we-offer-title">
                <br />Solution
              </AntTitle>
              <Paragraph className="paragraph">
                Attempts to deal with this constraints from multiple dimensions
                <ul>
                  <li>
                    Create a new efficient, optimized technology driven market
                    place
                  </li>
                  <li>Enable the farmer with the best price for his produce.</li>
                  <li>
                    Boosting Rural economy by providing local employment to youth
                    in all districts in Karnataka
                  </li>
                  <li>
                    VikasBandhu would be single point to provide all the local
                    support to the farmers from sow to sell
                  </li>
                  <li>
                    VikasBandhu would provide the right linkage to the buyer for
                    getting the produce at the most efficient price.
                  </li>
                  <li>Enable a Win Win for Both the farmer and the buyer</li>
                </ul>

                <div>
                  <b style={{ display: "block", marginBottom: "12px" }}>Application available as Dev Release (alpha).</b>
                  <Image src={orange} preview={false} />
                  <b>Visit us at:</b>{" "}
                  <a
                    href="https://vikasbandhu.in/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <strong> vikasbandhu.in</strong>
                  </a>
                  <b>{" "}for more information</b><br />
                </div>
                <div className="app-download-row">
                  <strong>Vikasbandhu App</strong>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.vikasBandhu"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                      alt="Get it on Google Play"
                      style={{ width: "100px" }}
                    />

                  </a>
                  <Image src={orange} preview={false} />
                </div>
              </Paragraph>
            </Row>
          </Col>
        </Row>
      </div>


      {/* COMMODITIES SECTION */}
      <div id="commodities">
        <Head title="Commodities" />

        {/* Spices */}
        <Row className="spices-row" gutter={36} align="middle">
          <Col span={12} xs={24} md={12}>
            <Row className="title-row" align="middle" justify="start">
              <Image className="image-mobile" preview={false} src={spices} />
            </Row>
            <Row className="details-row" align="middle">
              <AntTitle level={4} className="what-we-offer-title">
                Spices
              </AntTitle>
              <Paragraph className="paragraph">
                Premium farm-sourced spices including Pepper, Turmeric, Chilli,
                Cardamom, Cinnamon, Star Anise, Cumin and Coriander. Available in
                bulk packaging for wholesalers and FPO distribution.
              </Paragraph>
            </Row>
          </Col>

          <Col span={12} xs={24} md={12}>
            <Image
              className="image-web slide-right"
              preview={false}
              src={spices}
            />
          </Col>
        </Row>

        {/* Pulses */}
        <Row className="pulses-row" gutter={36} align="middle">
          <Col span={12} xs={24} md={12}>
            <Image
              className="image-web slide-left"
              preview={false}
              src={pulses}
            />
          </Col>

          <Col span={12} xs={24} md={12}>
            <Row className="title-row" align="middle" justify="start">
              <Image className="image-mobile" preview={false} src={pulses} />
            </Row>
            <Row className="details-row" align="middle">
              <AntTitle level={4} className="what-we-offer-title">
                Pulses
              </AntTitle>
              <Paragraph className="paragraph">
                High-quality pulses including Toor Dal, Moong, Green Gram, Channa Dal,
                Urad and Masoor. Graded and quality tested for bulk rural supply chains.
              </Paragraph>
            </Row>
          </Col>
        </Row>
      </div>
      <br />
    </div>
  );
}
